import styled from 'styled-components';
import Container from 'components/Container';
import Divider from 'components/Divider';
import { getThemeColor } from 'utils/styled';
import { LIST_PADDING_PX } from './constants';
import { ListProps, ListStyleProps } from './types';

export const Root = styled(Container).attrs(
  ({ borderWeight, cornerRadius }: ListProps) => ({
    borderWeight: borderWeight ?? 'regular',
    cornerRadius: cornerRadius ?? 3,
    gutter: 0,
  }),
)<ListStyleProps>`
  background-color: ${getThemeColor('l2')};
  cursor: pointer;
  overflow: hidden;

  [aria-disabled='true'] {
    cursor: not-allowed;
  }

  ${({ $variant }) => $variant === 'grid' && 'display: grid;'}
`;

export const RowDivider = styled(Divider)`
  margin: 0;
  padding-left: ${LIST_PADDING_PX}px;
  padding-right: ${LIST_PADDING_PX}px;
`;
